import React from "react";
import * as _ from "lodash";
import { createStyles, Theme, makeStyles } from "@material-ui/core/styles";
import style from "./style";

// Create styles
const useStyles = makeStyles((theme: Theme) => createStyles(style(theme)));

// Props type
type props = {
  platform: string;
};

// Platform Component
export const 
Platform = (props: props): JSX.Element => {
  const { platform } = props;
  const classes = useStyles();
  const platformText= (platform || "").toString().trim().toUpperCase();

  if (_.isEmpty(platformText)) {
    return <></>;
  }

  const platformClass = _.isEqual(platformText, "FB") ? classes.platformTextFB : classes.platformTextIG;

  return <div className={platformClass}>{platformText}</div>;
};

export default Platform;
